import store from '@/store';
import i18n from '@/i18n';
import { EventBus } from '@/event-bus.js';
import { verifyAgentNeedQualifyJob } from '@/shared/utils/job-helpers';
import { ADD_MESSAGE_STATUS } from '@/store/mutation-types.js';

export default class HangupEvent {
  constructor(body) {
    console.log('%c [event]', 'color: #F44336;', JSON.stringify(body, null, 4));

    if (body.request == 'CLIENT') {
      EventBus.$emit('play-hangup-sound');
    }

    this._hangupJobVoice(body);
  }

  async _hangupJobVoice(body, tries = 0) {
    store.dispatch('jobs/setTransferAssisted', false);
    store.dispatch('jobs/setTransferAssistedAccepted', false);

    const job = store.getters['jobs/getJobByProtocol'](body.protocol);
    if (job) {
      store.dispatch('jobs/disableJob', body.protocol);
      store.dispatch('jobs/setStartDateQualifications', new Date());
      store.dispatch('jobs/updateAgentStatusVoice');

      if (!store.state.voice.errorCalling) {
        if (body.request && body.request == 'AGENT') {
          store.dispatch(
            'showSnackbar',
            { text: 'hangupVoiceCallAgent' },
            { root: true },
          );
        } else if (body.request && body.request == 'FAILURE') {
          store.dispatch(
            'showSnackbar',
            { text: 'hangupVoiceCallFailure' },
            { root: true },
          );
        } else {
          // store.dispatch('showSnackbar', { text: 'hangupVoiceCallClient' }, { root: true })
          store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'CANCEL');
        }
      } else {
        store.dispatch('voice/addErrorVoiceMessage', false);
      }

      if (verifyAgentNeedQualifyJob(job)) {
        EventBus.$emit('open-qualification-job', job);
      }

      setTimeout(() => {
        store.dispatch(
          'attendance/getStatusAgent',
          store.state.attendance.Attendance.agentId,
        );
      }, 800);

      return;
    } else {
      const ackRequesInformation = store.state.jobs.ackCallRequest.info;
      if (ackRequesInformation.hasOwnProperty('uniqueId')) {
        if (ackRequesInformation.phoneNumber == body.phone) {
          const notificationApp = {
            eventType: 'callLost',
            message: i18n.t('ackCallRequest.appNotification.callLost', {
              phoneNumber: ackRequesInformation.phoneNumber,
            }),
            title: i18n.t('types_alert.callLost'),
          };
          store.dispatch('addNotification', notificationApp);
          store.dispatch('jobs/ackCallRequestResetDialog');
          return;
        }
      }
    }

    setTimeout(() => {
      if (tries <= 5) {
        const tryHangup = tries + 1;
        console.log(
          'Não encontrei o job desligar a chamada... Tentando novamente. Tentativa: ' +
            tryHangup,
        );
        this._hangupJobVoice(body, tryHangup);
      }
    }, 2000);
  }
}
